<template>
    <div class="page-header">
        <div class="row">
            <div class="d-flex justify-content-between">
                <div class="col">
                    <h3 class="page-title">{{ title }}</h3>
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item">
                            <!-- <router-link to="/dashboard">{{path}}</router-link> -->
                            {{ path }}
                        </li>
                        <!-- <li class="breadcrumb-item"><router-link to="/employee/employees">{{text}}</router-link></li> -->
                        <li class="breadcrumb-item active">{{ text1 }}</li>
                    </ul>
                </div>
                <div class="mb-3 d-flex justify-content-end align-items-center gap-3">

                </div>
            </div>
        </div>
    </div>
    <div class="search-filters mb-4">
        <div class="row filter-row align-items-end justify-content-end">
            <!-- Location Filter Dropdown -->
            <div class="col-md-3 mb-0 form-focus select-focus">
                <vue-select :options="formattedLocationOptions" v-model="selectedLocation" placeholder="-" @update:modelValue="onSearchClick"/>
                <label class="focus-label ms-2">Select Location</label>
            </div>
            <div class="col-md-3 mb-0">
                <!-- <div class="row"> -->
                    <!-- Search Button -->
                    <!-- <div class=" col-md-6 mb-0">
                        <a href="javascript:;" class="btn btn-secondary w-100" @click="onSearchClick">Search</a>
                    </div> -->
                    <!-- Download Button -->
                    <!-- <div class="col-md-6 mb-0"> -->
                        <a href="javascript:;" class="btn btn-success w-100" :class="{ 'disabled': !details.length }"
                            @click="details.length && downloadUsersData()">
                            <span v-if="!DownloadLoad">Download</span>
                            <div class="d-flex justify-content-center text-center py-1 px-5" v-else>
                                <div class="spinner-border spinner-border-sm" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </a>
                    <!-- </div> -->
                <!-- </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { VUE_APP_API_BASE_URL } from "../../config";
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        path: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "",
        },
        text1: {
            type: String,
            default: "",
        },
        text2: {
            type: String,
            default: "",
        },
        text3: {
            type: String,
            default: "",
        },
        locationOptions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            details: [],
            DownloadLoad: false,
            selectedLocation: 'All Locations'
        };
    },
    computed: {
        formattedLocationOptions() {
            const locations = this.locationOptions.map(location => location.text);
            return ['All Locations', ...locations];
        }
    },
    methods: {
        updateStatus(details) {
            this.details = details;
            console.log('this.details', this.details);
        },
        onSearchClick() {
            // Find the location ID from the selected text
            let locationId = '';
            if (this.selectedLocation && this.selectedLocation !== 'All Locations') {
                const location = this.locationOptions.find(loc => loc.text === this.selectedLocation);
                locationId = location ? location.id : '';
            }
            this.$emit('location-changed', locationId);
        },

        downloadUsersData() {
            this.DownloadLoad = true;
            const params = {
                details: this.details
            }
            axios.post(`${VUE_APP_API_BASE_URL}/fire-register-pdf/download`, params,
                {
                    responseType: 'blob'
                }).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'fire-register-user-list.pdf');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(error => {
                    this.$toast.error(error.data.errors || 'Download failed');
                    console.error('Download failed:', error);
                })
                .finally(() => {
                    this.DownloadLoad = false;
                });
        },
    }
    // computed: {
    //     isShiftSchedulingRoute() {
    //         return this.$route.path === "/shift-scheduling";
    //     },
    //     isShiftListRoute() {
    //         return this.$route.path === "/shift-list";
    //     },
    // },
}
</script>